module.exports = __webpack_public_path__ + "images/5024fb992a347770433d8c1b6314474c.png";


//////////////////
// WEBPACK FOOTER
// ./js/components/assets/man/2.png
// module id = 362
// module chunks = 0